<ng-container *ngIf="user">
  <img
    src="{{ user.photoURL }}"
    class="rounded float-left m-0 mr-1"
    [alt]="user.displayName"
  />
  <small>Hello {{ user.displayName }}!</small><br />
  Logout
</ng-container>
